import { useCallback, useEffect, useState } from 'react'

export const useIsMobile = (breakpoint = 768) => {
  const getIsMobile = useCallback(
    () =>
      typeof window !== 'undefined' ? window.innerWidth < breakpoint : false,
    [breakpoint]
  )

  const [isMobile, setIsMobile] = useState(getIsMobile)

  useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile())
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint, getIsMobile])

  return isMobile
}
